// src/lib/shared-prefs.ts
// The ONE canonical UiPrefs instance. Constructed once in main.tsx before
// render(<App/>) and new Phaser.Game(...). App takes it as a prop;
// BootScene.create re-registers it on the Phaser registry as 'uiPrefs' so
// PlayScene/MenuScene read registry.get('uiPrefs'). A test (set null) resets it.
// See spec §3.3.
import type { UiPrefs } from '@/lib/ui-prefs';

let shared: UiPrefs | null = null;

export function setSharedUiPrefs(prefs: UiPrefs | null): void {
  shared = prefs;
}

export function getSharedUiPrefs(): UiPrefs {
  if (shared === null) {
    throw new Error('[shared-prefs] getSharedUiPrefs() called before setSharedUiPrefs() — wire it up in main.tsx');
  }
  return shared;
}
